import axios from "axios";
import { getBaseUrl, Microservice } from "../constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface ForgotPasswordRequest {
  email: string;
}

const forgetpassword = async ({ email }: ForgotPasswordRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/forgot`,
      { email },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (response?.data?.status === 500) {
      throw new Error(response?.data?.message);
    }

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default forgetpassword;
